<template>
  <div class="fromList" v-loading="Delectloading" :element-loading-text="textContent">
    <div class="right">
      <tree />
    </div>
    <div class="leftN">
      <div class="storch">
        <div class="inputs">
          <el-input placeholder="请输入内容" v-model="search" class="input-with-select" style="width:300px">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
          <div class="btnes">
            <el-button type="success" @click="addContent" style="margin-left:10px">查询</el-button>
          <el-button type="primary" icon="el-icon-edit" @click="lookDlg()">注册</el-button>
          </div>
        </div>
      </div>
      <el-table
        :data="tabbData"
        stripe
        style="width:100%"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        border
      >
        <el-table-column label="组织名称" align="center" fixed prop="username"></el-table-column>
        <el-table-column label="密码" :show-overflow-tooltip="true" align="center" prop="password"></el-table-column>
        <el-table-column
          label="设备名称"
          :show-overflow-tooltip="true"
          align="center"
          sortable
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.roletype == 0? '平台账号' :scope.row.roletype==1 ?'经销商类账号' : '客户类账号' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="信息类型" :show-overflow-tooltip="true" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.roletype1 == 0 ? '主账号' :'子账号' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="最新报警"
          :show-overflow-tooltip="true"
          align="center"
          width="120"
          prop="nationality"
        ></el-table-column>
        <!-- <el-table-column label="操作" align="center" width="300">
          <template slot-scope="{row}">
            <el-button size="mini" icon="el-icon-view" round type="info" @click="detileData(row)">详情</el-button>
            <el-button
              size="mini"
              @click="editFrom(row)"
              round
              icon="el-icon-edit"
              type="primary"
            >修改</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="deleData(row)"
              icon="el-icon-delete"
              round
            >删除</el-button>
          </template>
        </el-table-column>-->
      </el-table>

      <!-- total="tableQuery.total" :getTableList="PostJsonData" -->
      <!-- <Page-helper :page-data="{name:123}"></Page-helper> -->
      <!-- 设备添加 -->
      <!-- current-page.sync 当前页数 -->
      <!--  :page-size 每页展示的页数 -->
      <!--  :page-sizes="pageSizes" 下拉的页数 -->

      <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="tableQuery.page"
      :page-size="tableQuery.rows"
       :page-sizes="pageSizes"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableQuery.total"
      ></el-pagination>-->
      <!-- 封装的分页 -->

      <!-- 添加要素 -->
      <el-dialog
        title="提示"
        :visible.sync="dialogVisibleAdd"
        width="40%"
        :close-on-click-modal="false"
      >
        <add :diohide="diohide" />
        <span slot="footer" class="dialog-footer addcentent"></span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import add from "./components/add";
import { userList } from "@/network/index";
import { setTimeout } from "timers";
import PageHelper from "@/components/common/PageHelper";
import tree from "@/components/common/tree";
export default {
  components: {
    PageHelper,
    tree,
    add
  },
  data() {
    return {
      search: "",
      dialogVisibleAdd: false,
      tabbData: [],
      Delectloading: false, //加载图表
      textContent: "正在努力加载中..." //加载提示文字
    };
  },
  mounted() {
    this.userList();
  },
  methods: {
    // 详情
    detileData() {
      this.dialogVisibleAdd = true;
    },
    //修改
    editFrom() {
      this.dialogVisibleAdd = true;
    },
    //  删除
    deleData(e) {
      let { uuid } = e;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
         closeOnClickModal:false,
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //获取用户列表
    async userList() {
      this.Delectloading = true;
      const { code, data, msg } = await userList();
      console.log(data);

      if (code) {
        this.tabbData = data;
        this.Delectloading = false;
      } else {
        this.Delectloading = false;
        this.$message.error(msg);
      }
    },
    diohide() {
      this.dialogVisibleAdd = false;
    },
    lookDlg() {
      this.dialogVisibleAdd = true;
    },
    // 查询
    addContent() {},
    deiName() {}
  }
};
</script>
<style >
.fromList {
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.right {
  width: 257px;
  height: 100%;
  overflow: auto;
}
.leftN {
  /* flex: 80%; */
  width: 80%;
  padding: 0 10px;
}
.inputs {
  display: flex;
  width: 100%;
  padding: 0 0 10px 0;
}
.btnes{
  display: flex;
}
</style>
